import { IdentiteService } from '../../../identite/shared/services/identite.service';
import { Component, OnInit, Input } from '@angular/core';
import { imgCardDrop } from '../../classes/animations';
import { FormControl } from '@angular/forms';
import { AlertService } from '../../services/alert.service';
import { TRANSLATE } from '../../classes/translatable';
import { AclAccess } from '../../../configuration/shared/classes/acl_access';
import { StorageService } from '../../services/storage.service';
import { Provenance } from '../../../identite/shared/classes/provenance';

@Component({
    selector: 'app-admin-list-provenance',
    templateUrl: './admin-list-provenance.component.html',
    styleUrls: ['./admin-list-provenance.component.css'],
    animations: [imgCardDrop]
})
export class AdminListProvenanceComponent implements OnInit {

    provenances: Provenance[];
    newProvenance = new Provenance();
    selected = new FormControl(0);

    aclConfig: AclAccess;

    @Input()
    triggerReload: () => void;

    constructor(
        private identiteService: IdentiteService,
        private alertService: AlertService,
        private storageService: StorageService
    ) { }

    ngOnInit() {
        this.aclConfig  = new AclAccess(this.storageService.getAcl('configuration'));
        this.provenances = [];
    }


    getProvenance() {
        this.provenances = [];
        this.identiteService.getProvenance()
        .subscribe(retour => {
            if (retour.status === 200) {
                retour.data.forEach(element => {
                    this.provenances.push(new Provenance(element));
                });
            }
        });
    }


    selectTab(event: any) {
        this.selected.setValue(event);
        if (event === 1) {
            this.getProvenance();
        }
    }

    insertProvenance(provenance: Provenance) {
        this.identiteService.insertProvenance(provenance)
        .subscribe(retour => {
            if (retour.status === 200) {
                this.newProvenance = new Provenance();
                this.alertService.success(TRANSLATE('Provenance ajoutée avec succès'));
                if (this.triggerReload) {
                    this.triggerReload();
                }
            } else {
                this.alertService.error(TRANSLATE(retour.message));
            }
        });
    }

    updateProvenance(provenance: Provenance) {
        this.identiteService.updateProvenance(provenance.prv_id, provenance)
        .subscribe(retour => {
            if (retour.status === 200) {
                this.alertService.success(TRANSLATE('Provenance modifiée avec succès'));
                if (this.triggerReload) {
                    this.triggerReload();
                }
            } else {
                this.alertService.error(TRANSLATE(retour.message));
            }
        });
    }

    deleteProvenance(provenance: Provenance) {
        this.identiteService.deleteProvenance(provenance.prv_id)
        .subscribe(retour => {
            if (retour.status === 200) {
                this.alertService.success(TRANSLATE('Provenance supprimée avec succès'));
                this.getProvenance();
                if (this.triggerReload) {
                    this.triggerReload();
                }
            } else {
                this.alertService.error(TRANSLATE(retour.message));
            }
        });
    }
}
